module.exports = __webpack_public_path__ + "static/JoeMartone-50-518347541b911ef1c8f8fc5855148ab4.jpg";